/**
 * Executes a callback function after the transition or animation ends on the target node
 * @param {Element} targetNode - The DOM element to observe for transitions/animations
 * @param {Function} executableBlock - The function to execute after the transition/animation ends
 * @param {Object|null} context - The context to bind to the executable block, defaults to null
 */
export const executeAfterTransition = function (targetNode, executableBlock, context = null) {
  targetNode.one(
    'transitionend animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
    context !== null ? executableBlock.bind(context) : executableBlock
  );
};